import { render } from "./About.vue?vue&type=template&id=0e60640a"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=0e60640a&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__